import React,{useState} from "react";
import toast, { Toaster } from "react-hot-toast";
import { useHomeContext } from "../../../context/HomeContext";
import { useAuth } from "../../../context/auth";
import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { ThreeDots } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";

const UpdateProfile = () => {
    const { token, user } = useAuth();
    const navigate = useNavigate();
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
  return (
    <div>
        
    </div>
  )
}

export default UpdateProfile